import { render, staticRenderFns } from "./aulasIntrutor.vue?vue&type=template&id=2a6109df&scoped=true"
import script from "./aulasIntrutor.vue?vue&type=script&lang=js"
export * from "./aulasIntrutor.vue?vue&type=script&lang=js"
import style0 from "./aulasIntrutor.vue?vue&type=style&index=0&id=2a6109df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6109df",
  null
  
)

export default component.exports